export default "__VITE_ASSET__DPQQLl3d__"